module.exports = __webpack_public_path__ + "static/media/masterIcon.0848e575.png";